export const getInvoiceStatusVariant = (status: string) => {
  let variant:
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'default'
    | 'warning'
    | 'brand'
    | 'success'
    | 'info'
    | 'error'
    | null
    | undefined = undefined;
  switch (status) {
    case 'DUE':
      variant = 'warning';
      break;
    case 'PROCESSING':
      variant = 'info';
      break;
    case 'PAID':
      variant = 'success';
      break;
    case 'SETTLED':
      variant = 'success';
      break;
    default:
      variant = 'default';
      break;
  }
  return variant;
};
